<template>
  <div class="layout-wrapper">
    <div class="d-flex align-baseline w-100 mb-4 mt-1">
      <v-card-title class="top-title">Scheduled Profiles</v-card-title>
      <v-spacer></v-spacer>
      <v-btn class="primary-btn px-6" depressed @click="handleCreateNewScanDialog(true)">Add Profile</v-btn>
    </div>
    <v-card class="light-card">
      <ScansList
        :items="scans"
        @onScheduleClick="(data) => handleScheduleDialog(true, data)"
        @onEdit="handleEdit"
        @onDelete="handleDelete"
      />
    </v-card>
    <div v-if="showCreateDialog">
      <NewScanDialog
        :show="showCreateDialog"
        :active="editingItem"
        @onClose="handleCreateNewScanDialog(false)"
      />
    </div>
  </div>
</template>

<script>
import ScansList from '../components/Scheduling/ScansList'
import NewScanDialog from '../components/Scheduling/NewScanDialog'
import { mapState } from 'vuex'

export default {
  name: 'Scheduling',
  components: {
    ScansList,
    NewScanDialog
  },
  data () {
    return {
      showCreateDialog: false,
      createScanMode: '',
      activeId: null,
      editingItem: null
    }
  },
  computed: {
    ...mapState({
      scans: state => state.schedulingServices.scans
    })
  },
  methods: {
    handleScheduleDialog (show = true, e) {
      if (show) {
        this.createScanMode = e.mode
        this.activeId = e.id
      } else {
        this.activeId = null
        this.createScanMode = ''
      }
    },
    handleCreateNewScanDialog (show = true) {
      this.showCreateDialog = show
      if (!show) {
        this.editingItem = null
      }
    },
    handleEdit (editingItem) {
      this.showCreateDialog = true
      this.editingItem = editingItem
    },
    handleDelete (id) {
      this.$store.dispatch('schedulingServices/deleteScan', id)
    }
  }
}
</script>
